export const pushGTMEvent = (event) => {
  if (typeof window === "undefined") return;
  if (!window.dataLayer) {
    window.dataLayer = [];
  }

  window.dataLayer.push(event);
};

export const trackPageView = (path) => {
  pushGTMEvent({
    event: "pageview",
    page_path: path,
  });
};

export const trackUser = ({ userId, role }) => {
  pushGTMEvent({
    event: "user_context",
    user_id: userId,
    user_role: role,
  });
};

export const isGTMReady = () => {
  return typeof window !== "undefined" && window.dataLayer;
};

export const ensureDataLayer = () => {
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
  }
};
